export default {
}



// WEBPACK FOOTER //
// ./src/mixins/NewsletterMixin.js